import Vue from 'vue'
import App from '@infinity/intelligent-match/App.vue'
// @ts-ignore
import VueTestAttribute from 'vue-test-attribute'
// @ts-ignore
import wrap from '@vue/web-component-wrapper'
import InfinityPopover from '@infinity/shared/plugins/infinity-popover'
import InfinityTime from '@infinity/shared/plugins/infinity-time'
import InfinityServices from '@infinity/shared/plugins/infinity-services'
import store from '@/store'
import router from '@/router'
import '@infinity/shared/styles/index.scss'

export const WebComponentTag = 'intelligent-match'

Vue.config.productionTip = false

Vue.use(InfinityServices)
Vue.use(VueTestAttribute)
Vue.use(InfinityPopover)
Vue.use(InfinityTime)

Vue.mixin({ store, router })

const WrappedComponent = wrap(Vue, App)

// @ts-ignore despite what typescript says, extending HTMLElement is valid
class IntelligentMatchElement extends WrappedComponent {
  _wrapper?: Vue;

  disconnectedCallback () {
    if (super.disconnectedCallback) {
      super.disconnectedCallback()
    }

    // The wrapped Vue instance is stored on `this._wrapper`
    // by @vue/web-component-wrapper
    if (this._wrapper) {
      this._wrapper.$destroy()
      this._wrapper = undefined
    }
  }
}

if (window.customElements.get(WebComponentTag) === undefined) {
  window.customElements.define(WebComponentTag, IntelligentMatchElement as unknown as CustomElementConstructor)
}
